import { TemplatePage } from './types';

const liveStreamSpiritualTheme: TemplatePage = {
  header: {
    color: '#FEFAEE',
    icon: 'images/video-templates/spiritual_theme.jpg',
    title: 'Live Stream Templates — Spiritual Theme',
    title_meta: '10+ Free Live Stream Overlay Templates — Spiritual Theme',
    description_meta:
      'Create a peaceful atmosphere for your live streams with Wave.video’s spiritual-themed templates. ' +
      'The set contains free transition screens, overlays, and frames.',
    description:
      'Create a peaceful atmosphere for your live streams with Wave.video’s spiritual-themed templates. ' +
      'You will get a set of pre-designed overlays, transition screens, and frames that perfectly fit multistreaming services like' +
      ` <a href=https://wave.video/live-streaming/streaming-software class="blackLink">Wave.video Live Streaming Studio</a>.`
  },
  footer: {
    category: 'Live streaming spiritual theme',
    description:
      'With Wave.video’s themed collections of editable overlay and transition screen templates, you will ' +
      'tangibly increase the effectiveness of your live streams! With no design background, you will make ' +
      'beautiful visual components that make you look like a pro. Create eye-catching thumbnails, countdown, ' +
      'intro, lower thirds, be right back screen in minutes! All you need to do is to pick the best-looking ' +
      'template and replace some elements with your own - that easy.'
  },
  content: [
    {
      type: 'templates',
      title: 'Live streaming spiritual theme',
      search: { name: 'SpiritualTheme', tags: 'SpiritualTheme' }
    },
    { type: 'calendar' }
  ]
};

export default liveStreamSpiritualTheme;
